import * as React from 'react';
import * as cx from 'classnames';
import { AssertExtends } from 'lib/assertExtends';
import { noDefault } from 'lib/eventWrappers';

import SuperCritical from 'lib/supercritical';

import { AddPortCall, TabId } from './model';

import { ErrorModal } from 'core/validationerror/view';

import { AddPortCallBerthsTabView } from './berthsview';
import { AddPortCallCoordinationsTabView } from './coordinationsview';
import { AddPortCallItineraryTabView } from './itineraryview';
import { AddPortCallPilotsTabView } from './pilotsview';
import { AddPortCallReviewTabView } from './reviewview';
import { AddPortCallSummaryTabView } from './summaryview';
import { AddPortCallVesselTabView } from './vesselview';

export const AddPortCallView = SuperCritical(({ model: m } : { model : AddPortCall }) =>
    <div className="addportcall">
        <header className="add-pc-page-header">
            <div className="pc-page-title page-title">Add PortCall</div>
            <TabIndicators model={m} />
        </header>
        <CurrentTabContents model={m} />
        <NavigationControls model={m} />
        <LoadingIcon model={m} />
        <ErrorModal
            errors={m.Validation}
            shown={m.ShowValidationErrors}
            title="There are issues with your PortCall"
        />
    </div>
);

const TabIndicators = SuperCritical(({ model: m } : { model : AddPortCall }) => {
    const
        availableTabs = m.AvailableTabs(),
        currentIdx = availableTabs.indexOf(m.CurrentTab().id);
    return (
        <div className="tab-indicators">
            {availableTabs.map((tabId, i) => [
                i > 0 ?
                    <span
                        className={cx(
                            'tab-indicator-separator fa fa-chevron-right',
                            { fulfilled: i <= currentIdx }
                        )}
                        key={`separator-${tabId}`}
                    /> :
                    null,
                <span
                    className={cx('tab-indicator', { fulfilled: i <= currentIdx })}
                    onClick={i <= currentIdx ? () => m.JumpBackToTab(tabId) : undefined}
                    key={`indicator-${tabId}`}
                >
                    {TabName(tabId)}
                </span>
            ])}
        </div>
    );
});

function TabName(id : TabId) {
    if      (id === TabId.Berths       ) return 'Berths';
    else if (id === TabId.Coordinations) return 'Coordinations';
    else if (id === TabId.Itinerary    ) return 'Itinerary';
    else if (id === TabId.Pilots       ) return 'Pilots';
    else if (id === TabId.Review       ) return 'Review';
    else if (id === TabId.Summary      ) return 'Summary';
    else if (id === TabId.Vessel       ) return 'Vessel';
    else return null as AssertExtends<typeof id, never>;
}

const LoadingIcon = SuperCritical(({ model: m } : { model : AddPortCall }) =>
    m.Loading() ? <div className="loading-icon"></div> : null
);

const CurrentTabContents = SuperCritical(({ model: m } : { model : AddPortCall }) => {
    window.scrollTo(0, 0);
    const tab = m.CurrentTab();
    if      (tab.id === TabId.Berths       ) return <AddPortCallBerthsTabView model={tab.model} />;
    else if (tab.id === TabId.Coordinations) return <AddPortCallCoordinationsTabView model={tab.model} />;
    else if (tab.id === TabId.Itinerary    ) return <AddPortCallItineraryTabView model={tab.model} />;
    else if (tab.id === TabId.Pilots       ) return <AddPortCallPilotsTabView model={tab.model} />;
    else if (tab.id === TabId.Review       ) return <AddPortCallReviewTabView model={tab.model} />;
    else if (tab.id === TabId.Summary      ) return <AddPortCallSummaryTabView model={tab.model} />;
    else if (tab.id === TabId.Vessel       ) return <AddPortCallVesselTabView model={tab.model} />;
    else return null as AssertExtends<typeof tab, never>;
});

const NavigationControls = SuperCritical(({ model: m } : { model : AddPortCall }) =>
    <div className="navigation-controls">
        <div className="back-button-shell">
            {m.HasPreviousTab() &&
                <button className="pc-button back-button" disabled={m.Submitting()} onClick={m.GoToPreviousTab}>Back</button>
            }
        </div>
        <div className="next-button-shell">
            {!m.SubmissionSucceeded() &&
                <a
                    href=""
                    onClick={noDefault(() => window.history.back())}
                >
                    Cancel
                </a>
            }
            <button
                className="pc-button next-button"
                disabled={!m.CanProceed() || m.Submitting()}
                onClick={
                    m.HasNextTab() ? m.GoToNextTab :
                    m.SubmissionSucceeded() ? () => window.history.back() :
                    m.Submit
                }
                tabIndex={1000}
            >
                {m.HasNextTab() ? 'Next' : m.SubmissionSucceeded() ? 'OK' : 'Submit'}
            </button>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/addportcall/view.tsx